var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 52,
    viewBox: "0 0 128 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 02",
    opacity: 0.2,
    d: "M128 21.7649V52H0V30.5232C3.44922 33.32 6.89258 35.9598 10.3359 37.971C21.3544 44.4068 32.3729 44.4068 43.3914 36.6838C48.9006 32.8223 54.4583 27.0302 60.0158 21.238C65.5734 15.4458 71.131 9.65371 76.6402 5.79219C87.6587 -1.93073 98.6772 -1.93073 109.696 5.79219C113.34 8.34663 116.985 11.7459 120.636 15.1518C123.087 17.4377 125.541 19.7266 128 21.7649Z",
    fill: "#17B26A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/1_1.fc91c3cda7102abdec7515f0123739f8.svg";
export { ForwardRef as ReactComponent };